import { useContext, useRef, useState } from "react";

import { Image } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import logout from "../../assets/images/logout.svg";
import { useOnClickOutside } from "../../hooks/useOnClickOutside";
import { cookies } from "../../utils/cookies";
import { UserContext } from "./UserContext";
import { USER_ROLE_LABELS } from "./globalValues";
import "./index.css";

interface Props {
  data: string;
  role?: unknown;
  className?: string;
}

function DropdownSelect({ data }: Props) {
  const [show, setShow] = useState(false);
  const logoutBoxRef = useRef<HTMLDivElement>(null);

  const userContextValue = useContext(UserContext);
  // const { name, email } = userContextValue;
  const { name } = userContextValue;

  const role = userContextValue.role as keyof typeof USER_ROLE_LABELS;

  // const trimmedMail = email.substring(0, 15);

  const handleClickOutside = () => {
    setShow(false);
  };

  useOnClickOutside(logoutBoxRef, handleClickOutside);

  const history = useHistory();

  const logoutHandler = () => {
    // localStorage.clear();
    cookies.remove("token");

    history.push("/login");
  };

  return (
    <div className="logout-container">
      <button
        className={
          data.length === 2
            ? "user-logo rounded-circle p-2"
            : "user-logo-length rounded-circle p-2"
        }
        type="button"
        onClick={() => setShow(!show)}
      >
        {data}
      </button>
      <div ref={logoutBoxRef} className={show ? "showDiv" : "closeDiv"}>
        <div className="user-img-cont">
          <button className="lg-user-logo rounded-circle" type="button">
            {data}
          </button>
        </div>
        <div className="details-con">
          <p className="lg-user-name">{name}</p>
          <p className="lg-user-role">{USER_ROLE_LABELS[role]}</p>
          {/* {email.length > 19 ? (
            <span>{trimmedMail}...</span>
          ) : (
            <p className="lg-user-mail">{email}</p>
          )} */}
          <hr className="my-4" />
          <div className="logout" onClick={logoutHandler}>
            <Image
              src={logout}
              alt="Logout Icon"
              width={16}
              height={16}
              style={{ marginRight: "8px", verticalAlign: "middle" }}
            />
            <span style={{ fontSize: "14px" }}>Sign out</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DropdownSelect;
